enum CompanyActionTypes {
  LOAD_STATE = 'LOAD_STATE',
  SET_LOCATIONS = 'SET_LOCATIONS',
  SET_USERS = 'SET_USERS',
  SET_CLIENTS = 'SET_CLIENTS',
  SET_CAREPARTNERS = 'SET_CAREPARTNERS',
  RESET = 'RESET',
  SET_CARE_MANAGER_ACTIVITIES = 'SET_CARE_MANAGER_ACTIVITIES',
  SET_APPLICANTS = 'SET_APPLICANTS',
  SET_AWARD_TYPES = 'SET_AWARD_TYPES',
  SET_DEACTIVATION_REASONS = 'SET_DEACTIVATION_REASONS',
  SET_LOST_CLIENT_REASONS = 'SET_LOST_CLIENT_REASONS',
  SET_PROSPECT_LOST_CLIENT_REASON = 'SET_PROSPECT_LOST_CLIENT_REASON',
  SET_APPLICANT_STAGES = 'SET_APPLICANT_STAGES',
  SET_REFERRAL_PARTNERS = 'SET_REFERRAL_PARTNERS',
  SET_COMPANIES = 'SET_COMPANIES',
  SET_PROSPECT = 'SET_PROSPECT',
  SET_MILESTONES = 'SET_MILESTONES',
  SET_RATINGS = 'SET_RATINGS',
  SET_COMPANY_RATINGS = 'SET_COMPANY_RATINGS',
  SET_PRIORITY_INDEXES = 'SET_PRIORITY_INDEXES',
  SET_PRIORITY_INDEXES_CP = 'SET_PRIORITY_INDEXES_CP',
  SET_ACTIVITY_TYPES = 'SET_ACTIVITY_TYPES',
  SET_COMPANY_TYPES = 'SET_COMPANY_TYPES',
  SET_APPLICANT_ACTIVITY = 'SET_APPLICANT_ACTIVITY',
  SET_APPLICANT_SOURCES = 'SET_APPLICANT_SOURCES',
  SET_LEAD_SOURCES = 'SET_LEAD_SOURCES',
  SET_REFERRAL_ACTIVITY_TYPES = 'SET_REFERRAL_ACTIVITY_TYPES',
  SET_APPLICANT_ACTIVITY_TYPE = 'SET_APPLICANT_ACTIVITY_TYPE',
  SET_APPLICANT_ACTIVITY_TYPE_CATEGORY = 'SET_APPLICANT_ACTIVITY_TYPE_CATEGORY',
  SET_ACTIVITY_CATEGORY_MANAGEMENT = 'SET_ACTIVITY_CATEGORY_MANAGEMENT',
  SET_REFERRAL_PARTNERS_ACTIVITY_CATEGORY = 'SET_REFERRAL_PARTNERS_ACTIVITY_CATEGORY',
  SET_PROSPECT_ACTIVITY_CATEGORY = 'SET_PROSPECT_ACTIVITY_CATEGORY',
  SET_AUTHORIZATION_STAGES = 'SET_AUTHORIZATION_STAGES',
  SET_REAUTHORIZATION_STAGES = 'SET_REAUTHORIZATION_STAGES',
  SET_AUTHORIZATION_TYPES = 'SET_AUTHORIZATION_TYPES',
  SET_AUTHORIZATIONS = 'SET_AUTHORIZATIONS',
  SET_REQUESTED_STAGES = 'SET_REQUESTED_STAGES',
  SET_TAGS = 'SET_TAGS',
  SET_TAG_CATEGORY = 'SET_TAG_CATEGORY',
  SET_PROSPECT_STAGES = 'SET_PROSPECT_STAGES',
  SET_CONTACT_TYPES = 'SET_CONTACT_TYPES',
  SET_CONTACT_RELATIONSHIPS = 'SET_CONTACT_RELATIONSHIPS',
  SET_DISCIPLINARY_STEPS = 'SET_DISCIPLINARY_STEPS',
  SET_DISCIPLINARY_CATEGORIES = 'SET_DISCIPLINARY_CATEGORIES',
  SET_DISCIPLINARY_ACKS = 'SET_DISCIPLINARY_ACKS',
  SET_DISCIPLINARY_ATTENDANCE_TYPES = 'SET_DISCIPLINARY_ATTENDANCE_TYPES',
  SET_APPLICANT_THRESHOLD = 'SET_APPLICANT_THRESHOLD'
}

export { CompanyActionTypes };
